/**
 * Created by jv on 2019-09-10 (13:39).
 */
import utils from "Sources/utils/utils";
const log = require("Sources/utils/logger")();
import LanguageManager from "Sources/services/language-manager";

require("Styles/components/views/game-view.scss");

class GameView
{
  constructor(options)
  {
    this.key = options.key;
    this.$container = $(options.container);
    this.html = options.html;
    this.$element = null;

    this.gameSessionController = options.gameSessionController;

    this.hasRendered = false;
  }

  render()
  {
    this.hasRendered = false;

    this.$element = $(this.html);
    this.$container.append(this.$element);
    LanguageManager.applyLocale(this.$element);
  }

  show()
  {
    if(utils.isNotNull(this.$element) && this.$element.length)
    {
      this.$element.show();
    }
  }

  hide()
  {
    if(utils.isNotNull(this.$element) && this.$element.length)
    {
      this.$element.hide();
    }
  }

  destroy()
  {
    if(utils.isNotNull(this.$element) && this.$element.length)
    {
      this.$element.remove();
    }
  }

  onRender()
  {
    this.hasRendered = true;
  }

  _setUpEventListeners()
  {

  }
}

module.exports = GameView;



// WEBPACK FOOTER //
// ./app/js/components/game/views/game-view.js